import { render, staticRenderFns } from "./instagram.vue?vue&type=template&id=0d738701&"
import script from "./instagram.vue?vue&type=script&lang=js&"
export * from "./instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d738701')) {
      api.createRecord('0d738701', component.options)
    } else {
      api.reload('0d738701', component.options)
    }
    module.hot.accept("./instagram.vue?vue&type=template&id=0d738701&", function () {
      api.rerender('0d738701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/top/instagram.vue"
export default component.exports